import getDeliveryAddressAttribute from './getDeliveryAddressAttribute';

export default () => (_, getState) => {
  const deliveryTypeAttributes = getDeliveryAddressAttribute()(_, getState);
  return (deliveryTypeAttributes.length > 0) ? [deliveryTypeAttributes[0]] : [];
};
